import { render, staticRenderFns } from "./ReturnItem.vue?vue&type=template&id=60913777"
import script from "./ReturnItem.js?vue&type=script&lang=js&external"
export * from "./ReturnItem.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports